import addGeometryAndNamedValuesState from "./addGeometryAndNamedValuesState";
import createFilterQuery from "./createFilterQuery";
import handleCreateObjectWithInStatement from "./handleCreateObjectWithInStatement";
import handleRangedItems from "./handleRangedItems";

/**
 *
 * @param {object} dispatch
 * @param {object} data data to be filter based on it
 * @param {string} reducerOrState string => "state" , "reducer"
 * @param {*} view
 * @param {*} fields
 * @param {*} mapLayer
 * @param {*} domains
 * @param {array} orderByFields
 * @param {string} objName object name to be set with new filtered data
 * @param {function} setState object name to be set with new filtered data
 * @param {function} injectQuery a valid query to join with the resulted query make sure to add a "and / or" in the start of it
 */
async function handleEsriFilter(params) {
  const {
    data,
    dispatch,
    view,
    fields,
    orderByFields,
    featureLayer,
    domains,
    objName,
    reducerOrState,
    setState,
    injectQuery,
    queryFeaturesOptions = {},
    processData,
    preformExtraJob = () => {},
  } = params;
  const dataWithRangeHandled = handleRangedItems(data);
  const { objectWithoutIns, objectWithIn } =
    handleCreateObjectWithInStatement(dataWithRangeHandled);
  let query = createFilterQuery(objectWithoutIns, fields, objectWithIn);
  if (injectQuery) query = `${query} ${injectQuery}`;

  const result = await featureLayer.queryFeatures({
    where: query || `1=1`,
    outFields: "*",
    returnGeometry: true,
    outSpatialReference: view?.spatialReference,
    orderByFields: orderByFields || [],
    ...queryFeaturesOptions,
  });

  // extract attributes from features and add them to the new variable
  let res = addGeometryAndNamedValuesState(result.features, domains);
  if (processData) {
    res = processData(res);
  }
  preformExtraJob({ ...params, query });
  if (reducerOrState === "reducer")
    dispatch({ type: "INIT", payload: { [objName]: res } });
  if (reducerOrState === "state") setState(res);
  if (!reducerOrState) return res;
  return null;
}

export default handleEsriFilter;
